import { createAction, props } from '@ngrx/store';
import { TermsOfPaymentDTO } from '@iota/iota-management-portal-v4-client';

export enum TermsOfPaymentActionTypes {
    LoadTermsOfPayment = '[Company] Load Terms of Payment',
    LoadTermsOfPaymentSuccess = '[Company] Load Terms of Payment Success',
    LoadTermsOfPaymentFailure = '[Company] Load Terms of Payment Failure'
}
export const LoadTermsOfPayment = createAction(TermsOfPaymentActionTypes.LoadTermsOfPayment);

export const LoadTermsOfPaymentSuccess = createAction(
    TermsOfPaymentActionTypes.LoadTermsOfPaymentSuccess,
    props<{ data: TermsOfPaymentDTO[] }>()
);

export const LoadTermsOfPaymentFailure = createAction(TermsOfPaymentActionTypes.LoadTermsOfPaymentFailure, props<{ error: any }>());
